import { decode, naddrEncode } from "nostr-tools/nip19";
export class Address {
    kind;
    pubkey;
    identifier;
    relays;
    constructor(kind, pubkey, identifier, relays = []) {
        this.kind = kind;
        this.pubkey = pubkey;
        this.identifier = identifier;
        this.relays = relays;
    }
    static isAddress(address) {
        return Boolean(address.match(/^\d+:\w+:.*$/));
    }
    static from(address, relays = []) {
        const [kind, pubkey, identifier = ""] = address.match(/^(\d+):(\w+):(.*)$/).slice(1);
        return new Address(parseInt(kind), pubkey, identifier, relays);
    }
    static fromNaddr(naddr) {
        let decoded;
        try {
            decoded = decode(naddr);
        }
        catch (e) {
            // pass
        }
        if (decoded?.type !== "naddr") {
            throw new Error(`Invalid naddr ${naddr}`);
        }
        const { kind, pubkey, identifier, relays } = decoded.data;
        return new Address(kind, pubkey, identifier, relays);
    }
    static fromEvent(event, relays = []) {
        const identifier = event.tags.find(t => t[0] === "d")?.[1] || "";
        return new Address(event.kind, event.pubkey, identifier, relays);
    }
    toString = () => `${this.kind}:${this.pubkey}:${this.identifier}`;
    toNaddr = () => naddrEncode(this);
}
// Utils
export const getAddress = (e) => Address.fromEvent(e).toString();
//# sourceMappingURL=Address.js.map